var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-tabs"},[_c('ul',{staticClass:"container"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,class:_vm.active.toLowerCase()===item.id.toLowerCase() && 'active',on:{"click":function($event){return _vm.activeTabHandle(item.id)}}},[_c('span',{staticClass:"title-cn"},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }